import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Feature from "../components/Feature";
import ExploreJob from "../components/Explore-job";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { BiCheckCircle } from "../assets/icons/vander";
import { api } from "..";
import { useAuth } from "../utility/auth";
export default function Pricing() {
  const [plans, setPlans] = useState([]);
  const [session, setSession] = useState();
  const auth = useAuth();
  const navigate = useNavigate();
  // console.log("checking ENV>>", process.env.REACT_APP_PoolMan);
  const user = JSON.parse(auth.user);
  const handlePayment = async (amount) => {
    let merchantId = "67813d8f9159cb0e1eefeae0";
    let firstName = user.name;
    let lastName = "-";
    let email = user.email;
    let orderId = "" + user._id + "hero_" + new Date().getTime();
    try {
      await fetch("https://buy.cryptopool.money/api/session_p1", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer 47f221c1-e468-41d4-b249-121282a31f87`,
        },
        body: JSON.stringify({
          merchantId,
          fromAmount: amount,
          firstName,
          lastName,
          email,
          orderId,
          phone: "123456890",
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setSession(data.id);
        });
    } catch (error) {
      console.error(error);
      alert("Error in making payment, Try again later");
    }
  };

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await fetch(`${api}/plans`);
        if (response.ok) {
          const data = await response.json();
          console.log("DATA FROM PLans>>>>>", data);
          setPlans(data.data);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchPlans();
  }, []);
  useEffect(() => {
    if (session) {
      const url = `https://buy.cryptopool.money/link_p1.html?sessionId=${session}`;
      window.open(url, "_blank");
    }
  }, [session]);
  return (
    <>
      <Navbar navClass="justify-end nav-light" />

      <section className="relative table w-full py-36 bg-[url('../../assets/images/hero/bg.jpg')] bg-top bg-no-repeat bg-cover">
        <div className="absolute inset-0 bg-emerald-900/90"></div>
        <div className="container">
          <div className="grid grid-cols-1 text-center mt-10">
            <h3 className="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">
              Pricing Plans
            </h3>
          </div>
        </div>

        <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
          <ul className="breadcrumb tracking-[0.5px] breadcrumb-light mb-0 inline-block">
            <li className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white/50 hover:text-white">
              <Link to="/">HeroAcademi</Link>
            </li>
            <li
              className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white"
              aria-current="page"
            >
              Pricing
            </li>
          </ul>
        </div>
      </section>
      <div className="relative">
        <div className="shape absolute start-0 end-0 sm:-bottom-px -bottom-[2px] overflow-hidden z-1 text-white dark:text-slate-900">
          <svg
            className="w-full h-auto"
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      <section className="relative lg:py-24 py-16">
        <div className="container">
          <div className="grid md:grid-cols-3 grid-cols-1 gap-[30px]">
            {plans.map((item, id) => {
              return (
                <div
                  key={id}
                  className="group border border-transparent relative shadow hover:shadow-md dark:shadow-gray-800 rounded-md z-2 bg-white dark:bg-slate-900 transition-all duration-500"
                >
                  <div className="p-6 py-8">
                    <h6 className="text-lg font-bold uppercase mb-5 text-indigo-600">
                      {item.name}
                    </h6>

                    <div className="flex mb-5">
                      <span className="text-xl font-semibold">$</span>
                      <span className="price text-4xl font-semibold mb-0">
                        {item.price}
                      </span>
                      <span className="text-xl font-semibold self-end mb-1">
                        /mo
                      </span>
                    </div>

                    <ul className="list-none text-slate-400 border-t border-gray-100 dark:border-gray-700 pt-5">
                      {item.description.split(",").map((feature) => (
                        <li className="my-2 flex items-center">
                          <BiCheckCircle
                            className="text-indigo-600 text-xl me-2"
                            style={{ flexShrink: 0 }}
                          />
                          <span className="flex-grow">{feature}</span>
                        </li>
                      ))}

                      {/* <li className="my-2 flex items-center">
                        <BiCheckCircle className="text-indigo-600 text-xl me-2" />
                        Source Files
                      </li>
                      <li className="my-2 flex items-center">
                        <BiCheckCircle className="text-indigo-600 text-xl me-2" />
                        Free Appointments
                      </li>
                      <li className="my-2 flex items-center">
                        <BiCheckCircle className="text-indigo-600 text-xl me-2" />
                        Enhanced Security
                      </li> */}
                    </ul>
                    <button
                      onClick={
                        !auth.user
                          ? navigate("/login")
                          : () => handlePayment(item.price)
                      }
                      className="btn bg-indigo-600 hover:bg-indigo-700 border-emerald-600 hover:border-emerald-700 text-white rounded-md mt-5"
                    >
                      Try it Now
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {/* {session && (
          <iframe
            width="100%"
            height="800px"
            title="widget"
            src={`https://buy.cryptopool.money/link_p1.html?sessionId=${session}`}
          ></iframe>
        )} */}

        <Feature />
        <ExploreJob />
      </section>
      <Footer />
    </>
  );
}
